<div class=" container-scroller">
    <!-- <nav class="navbar default-layout-navbar p-0 fixed-top d-flex flex-row" style="width: 260px;height: 140px;">
        <div class="text-center navbar-brand-wrapper d-flex align-items-center justify-content-center"
            style="border-right: 1px solid #9c9fa6;border-bottom: 1px solid #9c9fa6;">
            <img src="../../assets/POA_IconLogo.png" style="height:130px; " />
            <img src="../../assets/POA_TextLogo.png" style="padding-top: 65px;" />
        </div>

    </nav> -->

    <div class="container-fluid page-body-wrapper" style="padding-left: 260px; top: 50px; position: absolute; z-index: -1;">
        <div class="main-panel" >
            <div class="content-wrapper" style="padding: 1.5rem .8rem .5rem 2rem;">
                <div class="page-header">
                    <h2 style="color: black !important;" class="page-title text-primary">Assign Employee</h2>
                </div>
                <div class="form" [hidden]="isShownWrite">
                    <div class="row" style="height: 5rem;">
                        <div class="col-lg-3">
                            <label>Customer Code</label><span style="color: red;">*</span><br />
                            <select class="txt-input" [(ngModel)]="onboardingid" disabled
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let Clnt of Clients" value={{Clnt.onboardingid}}>{{Clnt.customcode}}
                                </option>
                            </select>
                        </div>
                        <div class="col-lg-3">
                            <label>Contract</label><span style="color: red;">*</span><br />
                            <select class="txt-input" [(ngModel)]="contractsid"
                                style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                <option value="0" disabled>Select</option>
                                <option *ngFor="let cnt of Contracts" value={{cnt.contractsid}}>{{cnt.contractNumber}}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="row" style="width:100%;padding-left: 15px;padding-top: 14px; ">
                        <div class="col-lg-10" style="border: ridge;padding-bottom: 2em;">
                            <div class="col-lg-12" *ngFor="let ae of AsEmp">
                                <div class="row" style="padding-top:1em;">
                                    <div class="col-md-4" >
                                        <label>Assign Services</label><span style="color: red;">*</span><br />
                                        <select name="Service" id="{{ae.AssignService}}" class="txt-input">
                                            <option value="0" disabled selected>Select</option>
                                            <option value="PostAudit">Post Audit</option>
                                            <option value="BrokerRationalization">Broker Rationalization</option>
                                            <option value="TradeCompliance">Trade Compliance</option>
                                            <option value="Classification">Classification & FTA</option>
                                        </select>
                                    </div>

                                    <div class="col-md-4" >
                                        <label>Employee</label><span style="color: red;">*</span><br />
                                        <select name="Employee" id="{{ae.Employee}}" class="txt-input"
                                            style="border: 1px solid #9c9fa6 !important;border-radius: 5px !important;outline: none !important ;">
                                            <option value="0" disabled selected>Select</option>
                                            <option *ngFor="let emp of Employees" value={{emp.empid}}>{{emp.empName}}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4">
                                        <label>Role</label><span style="color: red;">*</span><br />
                                        <input type="text" class="txt-input" id={{ae.Role}} style="width: 85%;" />
                                        &nbsp;<img src="../../assets/Delete_Icon.png"  (click)="RemoveServices(ae)" />
                                    </div>
                                    
                                </div>
                                <div class="row" style="padding-top: 15px;">
                                    <div class="col-md-4" >
                                        <label>Start Date</label><span style="color: red;">*</span><br />
                                        <input type="date" class="txt-input" id={{ae.StartDate}} />
                                    </div>
                                    <div class="col-md-4" >
                                        <label>End Date</label><span style="color: red;">*</span><br />
                                        <input type="date" class="txt-input" id={{ae.EndDate}} />
                                        <span id={{ae.Empvar}} style="visibility: hidden;">{{ae.AssigEmpId}}</span>
                                    </div>
                                    <div class="col-md-3">
                                        
                                    </div>
                                    <div class="col-md-1" style="padding-top: 35px;">
                                       
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-8"></div>
                                <div class="col-lg-4" style="padding-top:1em;">
                                    <button class="bttn-save" (click)="AddEmp()">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-5" style="padding-top:1em;">
                            <label>Description</label> <br />
                            <textarea cols="40" rows="3" class="txt-input" [(ngModel)]="description"
                                id="description"></textarea>
                        </div>
                        <div class="col-lg-2" style="padding-top:4rem;" [hidden]="isShownActive">
                            <input type="checkbox" [(ngModel)]="Status"> Set As Inactive
                        </div>
                        <div class="col-lg-4" style="padding-top: 4rem;">
                            <button class="bttn-save " (click)="SubmitAsEmp()" [hidden]="isShownSaveBtn">SAVE</button>
                            &nbsp;&nbsp;
                            <button class="bttn-Update" (click)="UpdateAsEmp()"
                                [hidden]="isShownUpdateBtn">Update</button>&nbsp;&nbsp;
                            <button class="bttn-clear" (click)="ClearAsEmp()">Clear</button>
                        </div>
                    </div>

                </div>


                <div class="col-md-12" style="padding-bottom: 25px; text-align: Left;">
                    <span [hidden]="isShownError" style="color: red;">{{ErrorMsg}}</span>
                    <span [hidden]="isShownSuccess" style="color: green;">{{SuccessMsg}}</span>
                </div>
            </div>

            <div class="content-wrapper">

                <div class="row">
                    <div class="col-lg-12 grid-margin">
                        <div class="card">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12 grid-margin">
                                        <div class="card">
                                            <div class="card-body" style="padding: 0;">
                                                <div class="col-lg-12 form-inline"
                                                    style="border: 1px solid #9c9fa6; padding: 5px;background-color: #f0f0f1">
                                                    <div class="col-lg-3"></div>
                                                    <div class="col-lg-9" style="padding-right:0px;">
                                                        <div class="form-group" style="padding-left:55%;">
                                                            <div class="input-group">
                                                                <!-- <label style="padding-right: 25px;">Search</label> -->
                                                                <input type="text" placeholder="Search"
                                                                    (keyup)="applyFilter($event.target.value)"
                                                                    class="txt-Search"> <i class="fa fa-search fa-2x"
                                                                    style="color:#38C3FA;position: absolute;    left: 72%; top: 3px;"></i>
                                                                <!-- <input type="text" class="form-control"
                                                                    placeholder="Search..." aria-label="Search..."
                                                                    aria-describedby="basic-addon2">
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-sm btn-gradient-danger"
                                                                        type="button">Search</button>
                                                                </div> -->
                                                            </div>
                                                            <button type="button" class="btn btn-sm ">
                                                                <img src="../../assets/ExportPDF.png" />
                                                            </button>
                                                            <button type="button" class="btn  btn-sm">
                                                                <img src="../../assets/ExportExcel.png"
                                                                    (click)="exportexcel()" style="cursor: pointer;" />
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div class="col-sm-12 mat-elevation-z8"
                                                    style="box-shadow: unset;padding: 0px ;" #TABLE>
                                                    <table mat-table [dataSource]="dataSource" #table
                                                        style="width: 100%;" matSortmat-table [dataSource]="dataSource"
                                                        #table style="width: 100%;" matSort>
                                                        <ng-container matColumnDef="sno">
                                                            <th mat-header-cell *matHeaderCellDef
                                                                style="color:black !important;background-color: white">
                                                                S.NO </th>
                                                            <td mat-cell *matCellDef="let item; let j = index">
                                                                {{(j +1)  + (myPaginator.pageIndex * myPaginator.pageSize) }}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="clientid">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Customer Code</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditAssignEmp(element)"
                                                                style="cursor: pointer;"> {{element.clientid}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="contractid">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Contract</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditAssignEmp(element)"
                                                                style="cursor: pointer;"> {{element.contractid}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="assignService">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Assigned Services</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditAssignEmp(element)"
                                                                style="cursor: pointer;"> {{element.assignService}}
                                                            </td>
                                                        </ng-container>
                                                        <ng-container matColumnDef="status">
                                                            <th mat-header-cell *matHeaderCellDef mat-sort-header
                                                                style="color: black !important;background-color: white">
                                                                Status</th>
                                                            <td mat-cell *matCellDef="let element"
                                                                (click)="EditAssignEmp(element)"
                                                                style="cursor: pointer;"> {{element.status}}
                                                            </td>
                                                        </ng-container>

                                                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                                        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
                                                        </tr>
                                                    </table>
                                                    <mat-paginator #myPaginator [pageSizeOptions]="[5, 10,15, 20,30,40]"
                                                        showFirstLastButtons></mat-paginator>
                                                </div>



                                            </div>

                                        </div>
                                    </div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4"></div>
                                    <div class="col-lg-4">
                                        <!-- <p class="text-primary" style="float:right"><i>
                                                &nbsp;</i>Page 1,2,3,4<i>&nbsp;></i></p> -->
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>



</div>